import { render, staticRenderFns } from "./SidebarDropdown.vue?vue&type=template&id=545f8292&scoped=true&"
import script from "./SidebarDropdown.vue?vue&type=script&lang=js&"
export * from "./SidebarDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SidebarDropdown.vue?vue&type=style&index=0&id=545f8292&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545f8292",
  null
  
)

export default component.exports